module.exports = __webpack_public_path__ + "static/bsas006.thumb-b18160e3f8222f27994f31bea328f105.jpg";